export enum Branch {
  None = "None",
  TechRequest = "TechRequest",
  WarrantyClaim = "WarrantyClaim",
  CustomerSupportTicket = "CustomerSupportTicket",
  SparePartClaim = "SparePartClaim",
  OperationalSupportRequest = "OperationalSupportTicket",
}
